import { Component } from '@angular/core'
import { MbCheckoutRegions } from '../../../../models'
import { MbOrderDetailsBaseComponent } from '../mb-order-details-base.component'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-order-details-eu',
  templateUrl: './mb-order-details-eu.component.html',
  styleUrls: ['../mb-order-details-base.component.scss']
})
export class MbOrderDetailsEuComponent extends MbOrderDetailsBaseComponent {

  checkoutRegion = MbCheckoutRegions.EU

  constructor (protected orderService: OrderHistoryService) {
    super(orderService)
  }
}
